<template>
  <div>
    <section class="section">
      <div class="container" style="padding-top:50px;">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="columns">
              <div class="column is-4">
                <div class="box">
                  <div class="field has-addons">
                    <div class="control has-icons-right is-expanded">
                      <input
                        class="input"
                        v-model="folder"
                        name="folder"
                        maxlength="40"
                        v-on:keyup="sanitizeFolder"
                        placeholder="Ordner erstellen"
                      >
                    </div>
                    <div class="control" v-if="folder.length">
                      <a class="button is-info" @click="addFolder">Erstellen</a>
                    </div>
                  </div>
                </div>

                <div class="box" style="height:70vh;overflow: scroll;">
                  <table class="table is-bordered is-hoverable is-striped is-narrow is-fullwidth">
                    <thead>
                      <tr>
                        <th>Ordner</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <a @click="getS3Files('root')">/</a>
                        </td>
                      </tr>
                      <tr v-for="(i, index) in S3folders" :key="index">
                        <td>
                          <a @click="getS3Files(i)">{{ i }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="column is-8">
                <!----------- images ---------------------------------->
                <div class="box" v-if="showAdvSettings">
                  <div class="field">
                    <label class="label">Image quality</label>
                    <div class="control">
                      <input type="range" min="0" max="1" v-model.number="FMquality" step="0.1">
                      {{ FMquality }}
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Image width</label>
                    <div class="control">
                      <input type="number" v-model.number="FMwidth" class="input">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Image height</label>
                    <div class="control">
                      <input type="number" v-model.number="FMheight" class="input">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Maximum upload size</label>
                    <div class="control">
                      <input type="number" v-model.number="size" class="input">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">AutoCompress files bigger than</label>
                    <div class="control">
                      <input type="number" v-model.number="autoCompress" class="input">
                    </div>
                  </div>
                </div>

                <div class="box">
                  <div class="example-full" style="margin-bottom:20px;">
                    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                      <h3>Drop files to upload</h3>
                    </div>
                    <div class="upload">
                      <div class="table-responsive">
                        <table class="table is-striped is-fullwidth is-hoverable">
                          <thead>
                            <tr>
                              <th @click="showAdvSettings=!showAdvSettings">#</th>
                              <th>Thumb</th>
                              <th>Name</th>
                              <th>Size</th>
                              <th>Speed</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="!files.length">
                              <td colspan="7" class="has-text-centered">
                                <div style="padding: 5rem;">
                                  <p>Drop files anywhere to upload or</p>
                                  <label
                                    :for="name"
                                    class="button is-primary"
                                    style="margin-top: 1rem;"
                                  >Select Files</label>
                                </div>
                              </td>
                            </tr>
                            <tr v-for="(file, index) in files" :key="file.id">
                              <td>{{index}}</td>
                              <td>
                                <img v-if="file.thumb" :src="file.thumb" width="40" height="auto">
                                <span v-else>No Image</span>
                              </td>
                              <td>
                                <div v-if="file.active || file.progress !== '0.00'">
                                  <progress
                                    :class="{'progress': true, 'is-success': true, 'is-danger': file.error, 'is-warning': file.active}"
                                    role="progressbar"
                                    :value="file.progress"
                                    max="100"
                                  >{{ file.progress }}</progress>
                                </div>
                              </td>
                              <td>{{ convertBytes(file.size) }}</td>
                              <td>{{ convertBytes(file.speed) }}</td>

                              <td v-if="file.error">{{file.error}}</td>
                              <td v-else-if="file.success">success</td>
                              <td v-else-if="file.active">active</td>
                              <td v-else></td>
                              <td>
                                <a
                                  :class="{'button': true, disabled: file.active || file.success || file.error === 'compressing'}"
                                  @click.prevent="file.active || file.success || file.error === 'compressing' ? false :  onEditFileShow(file)"
                                >Edit</a>
                                <a
                                  :class="{'button': true, disabled: !file.active}"
                                  @click.prevent="file.active ? $refs.upload.update(file, {error: 'cancel'}) : false"
                                >Cancel</a>
                                
                                <a
                                  class="button"
                                  v-if="file.active"
                                  @click.prevent="$refs.upload.update(file, {active: false})"
                                >Abort</a>
                                <a
                                  class="button"
                                  v-else-if="file.error && file.error !== 'compressing' && $refs.upload.features.html5"
                                  @click.prevent="$refs.upload.update(file, {active: true, error: '', progress: '0.00'})"
                                >Retry upload</a>
                                <a
                                  :class="{'button': true, disabled: file.success || file.error === 'compressing'}"
                                  v-else
                                  @click.prevent="file.success || file.error === 'compressing' ? false : $refs.upload.update(file, {active: true})"
                                >Upload</a>
                                
                                <a class="button" @click.prevent="$refs.upload.remove(file)">Remove</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="example-foorer">
                        <file-upload
                          class="button"
                          aria-haspopup="true"
                          aria-controls="dropdown-menu"
                          :post-action="postAction + currentDirectory"
                          :extensions="extensions"
                          :accept="accept"
                          :multiple="multiple"
                          :directory="directory"
                          :size="size || 0"
                          :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                          :headers="headers"
                          :data="data"
                          :drop="drop"
                          :drop-directory="dropDirectory"
                          :add-index="addIndex"
                          v-model="files"
                          @input-filter="inputFilter"
                          @input-file="inputFile"
                          ref="upload"
                        >
                          <span>Select file</span>
                        </file-upload>

                        <a class="button" @click="onAddFolader">Add folder</a>
                        <!-- <a class="button" @click.prevent="addData.show = true">Add data</a> -->
                        <button
                          type="button"
                          class="button is-success is-pulled-right"
                          v-if="!$refs.upload || !$refs.upload.active"
                          @click.prevent="$refs.upload.active = true"
                        >
                          <span class="icon">
                            <i class="fa fa-arrow-up" aria-hidden="true"></i>
                          </span>
                          <span>Start Upload</span>
                        </button>
                        <button
                          type="button"
                          class="button is-danger is-pulled-right"
                          v-else
                          @click.prevent="$refs.upload.active = false"
                        >
                          <span class="icon">
                            <i class="fa fa-stop" aria-hidden="true"></i>
                          </span>
                          <span>Stop Upload</span>
                        </button>
                      </div>
                    </div>

                    <div
                      class="modal is-active"
                      v-if="addData.show"
                      id="modal-add-data"
                      tabindex="-1"
                      role="dialog"
                    >
                      <div class="modal-background"></div>
                      <div class="modal-content">
                        <div class="box">
                          <div class="modal-header">
                            <h5 class="modal-title">Add data</h5>
                            <button
                              type="button"
                              class="close"
                              @click.prevent="addData.show = false"
                            >
                              <span>&times;</span>
                            </button>
                          </div>
                          <form @submit.prevent="onAddData">
                            <div class="modal-body">
                              <div class="form-group">
                                <label for="name">Name:</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  required
                                  id="name"
                                  placeholder="Please enter a file name"
                                  v-model="addData.name"
                                >
                                <small class="form-text text-muted">
                                  Such as
                                  <code>filename.txt</code>
                                </small>
                              </div>
                              <div class="form-group">
                                <label for="type">Type:</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  required
                                  id="type"
                                  placeholder="Please enter the MIME type"
                                  v-model="addData.type"
                                >
                                <small class="form-text text-muted">
                                  Such as
                                  <code>text/plain</code>
                                </small>
                              </div>
                              <div class="form-group">
                                <label for="content">Content:</label>
                                <textarea
                                  class="form-control"
                                  required
                                  id="content"
                                  rows="3"
                                  placeholder="Please enter the file contents"
                                  v-model="addData.content"
                                ></textarea>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="button"
                                @click.prevent="addData.show = false"
                              >Close</button>
                              <button type="submit" class="button is-primary">Save</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    <div
                      class="modal is-active"
                      v-if="editFile.show"
                      id="modal-edit-data"
                      tabindex="-1"
                      role="dialog"
                    >
                      <div class="modal-background"></div>
                      <div class="modal-card card-margin">
                        <header class="modal-card-head">
                          <p class="modal-card-title">Edit image</p>
                          <button
                            class="delete"
                            @click.prevent="editFile.show = false"
                            aria-label="close"
                          ></button>
                        </header>

                        <form @submit.prevent="onEditorFile">
                          <section class="modal-card-body">
                            <div
                              class="form-group"
                              v-if="editFile.show && editFile.blob && editFile.type && editFile.type.substr(0, 6) === 'image/'"
                            >
                              <div class="edit-image">
                                <img :src="editFile.blob" ref="editImage">
                              </div>
                            </div>
                          </section>
                          <footer class="modal-card-foot">
                            <button
                              type="button"
                              class="button"
                              @click="editFile.cropper.rotate(-90)"
                              title="cropper.rotate(-90)"
                            >
                              <i class="fas fa-undo"></i>
                            </button>
                            <button
                              type="button"
                              class="button"
                              @click="editFile.cropper.rotate(90)"
                              title="cropper.rotate(90)"
                            >
                              <i class="fas fa-redo"></i>
                            </button>
                            
                            <button
                              type="button"
                              class="button"
                              @click="editFile.cropper.crop()"
                              title="cropper.crop()"
                            >
                              <i class="fa fa-check" aria-hidden="true"></i>
                            </button>
                            <button
                              type="button"
                              class="button"
                              @click="editFile.cropper.clear()"
                              title="cropper.clear()"
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <div class="is-pulled-right">
                              <button
                                type="button"
                                class="button"
                                @click.prevent="editFile.show = false"
                              >Close</button>
                              <button type="submit" class="button is-primary">Save</button>
                            </div>
                          </footer>
                        </form>
                      </div>
                    </div>
                  </div>

                  <table class="table is-bordered is-hoverable is-striped is-narrow is-fullwidth">
                    <thead>
                      <tr>
                        <th>
                          Dateiname
                          <a
                            class="icon is-pulled-right"
                            @click="getS3Files(currentDirectory)"
                          >
                            <i class="fas fa-sync-alt"/>
                          </a>
                          <a class="icon is-pulled-right" @click="showList=true">
                            <i class="fas fa-bars"/>
                          </a>
                          <a class="icon is-pulled-right" @click="showList=false">
                            <i class="fa fa-th-large"></i>
                          </a>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="background-color: #e8e8e8;">
                          <strong>
                            <span v-if="currentDirectory=='root'">/</span>
                            <span v-else>/{{ currentDirectory }}</span>
                          </strong>
                        </td>
                      </tr>
                      <tr v-if="showList" v-for="(i, index) in S3files" :key="index">
                        <td>
                          <a @click="deleteFile(i)" v-if="currentDirectory!='images'">
                            <span class="icon">
                              <i class="fas fa-trash-alt"/>
                            </span>
                          </a>
                          {{ i }}
                        </td>
                      </tr>
                      <tr v-if="!showList">
                        <td>
                          <div
                            class="columns is-multiline is-mobile"
                            v-masonry
                            transition-duration="0.3s"
                            item-selector=".bilder"
                          >
                            <div
                              v-masonry-tile
                              class="column is-3 bilder break-word"
                              v-for="(i, index) in S3files"
                              :key="index"
                            >
                              <img :src="assetsBaseUrl + i">
                              <br>
                              <a @click="deleteFile(i)" v-if="currentDirectory!='images'">
                                <span class="icon">
                                  <i class="fa fa-trash-o"></i>
                                </span>
                              </a>
                              {{ i }}
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="!S3files.length">
                        <td>Dieser Ordner ist leer</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Cropper from 'cropperjs'
import ImageCompressor from '@xkeshi/image-compressor'
import FileUpload from 'vue-upload-component'
import axios from 'axios'
import { VueMasonryPlugin } from 'vue-masonry'

Vue.use(VueMasonryPlugin)

Vue.use(VeeValidate)

export default {
  data() {
    return {
      // filemanager
      showAdvSettings: false,
      showList: true,
      S3folders: [],
      S3files: [],
      currentDirectory: 'root',
      folder: '',
      FMquality: 0.8,
      FMwidth: 1350,
      FMheight: 1350,
      // vue-upload data
      ddActive: false,
      files: [],
      accept: 'image/jpeg,image/png,image/gif',
      // accept: 'image/png,image/gif,image/jpeg,image/webp',
      extensions: 'jpg,jpeg,png,gif',
      // extensions: 'gif,jpg,jpeg,png,webp',
      // extensions: ['gif', 'jpg', 'jpeg','png', 'webp'],
      // extensions: /\.(gif|jpe?g|png|webp)$/i,
      minSize: 1024,
      // size: 1024 * 1024 * 10,
      size: 300000,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      postAction: 'https://api2.urlaubimwaldviertel.at/api/file/',
      putAction: 'https://api2.urlaubimwaldviertel.at/api/file/',
      headers: {
        'x-xsrf-token': this.getCookie('XSRF-TOKEN')
      },
      data: {},
      autoCompress: 250000,
      uploadAuto: false,
      isOption: false,

      addData: {
        show: false,
        name: '',
        type: '',
        content: ''
      },
      editFile: {
        show: false,
        name: ''
      }
    }
  },
  watch: {
    // vue-upload
    'editFile.show'(newValue, oldValue) {
      // error
      if (!newValue && oldValue) {
        this.$refs.upload.update(this.editFile.id, {
          error: this.editFile.error || ''
        })
      }

      if (newValue) {
        this.$nextTick(function() {
          if (!this.$refs.editImage) {
            return
          }
          let cropper = new Cropper(this.$refs.editImage, {
            // aspectRatio: 16 / 9,
            autoCrop: false
          })
          this.editFile = {
            ...this.editFile,
            cropper
          }
        })
      }
    },
    'addData.show'(show) {
      if (show) {
        this.addData.name = ''
        this.addData.type = ''
        this.addData.content = ''
      }
    }
  },
  metaInfo: {
    link: [
      {
        rel: 'stylesheet',
        href: 'https://cdn.jsdelivr.net/npm/cropperjs/dist/cropper.css'
      }
    ],
    meta: [{ name: 'robots', content: 'NOINDEX, NOFOLLOW' }]
  },
  methods: {
    addFolder() {
      var i = this.S3folders.indexOf(this.folder)
      if (i === -1) {
        const vm = this
        axios
          .get('/folders/' + this.folder)
          .then(function(res) {
            vm.getS3Folders('/')
            vm.folder = ''
          })
          .catch(function(error) {
            console.log(error)
          })
      } else {
        alert('Dieser Ordnername wird bereits verwendet!')
      }
    },
    deleteFile(v) {
      const vm = this
      if (confirm('Sind Sie sich sicher?') === true) {
        axios
          .post('/deletefile', { path: v })
          .then(function(response) {
            if (response.data.length) {
              alert(
                'Die Datei kann nicht gelöscht werden. Sie wird auf folgenden Seiten verwendet:\n\n' +
                  response.data
                    .map(function(elem) {
                      return elem.headline
                    })
                    .join('\n')
              )
            } else {
              vm.getS3Files(vm.currentDirectory)
            }
          })
          .catch(function(error) {
            alert('Es ist leider ein Fehler aufgetreten!')
            console.log(error)
          })
      }
    },
    sanitizeFolder() {
      this.folder = this.folder.replace(/[^a-zA-Z0-9-]/g, '')
    },
    getS3Files(v) {
      const vm = this
      axios
        .get('/files/' + v)
        .then(function(res) {
          vm.S3files = res.data
          vm.currentDirectory = v
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    getS3Folders() {
      const vm = this
      axios
        .get('/folders')
        .then(function(res) {
          vm.S3folders = res.data
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    convertBytes(v) {
      return Math.round(v * 0.001) + ' kB'
    },
    // vue-upload
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前

        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }

        // Automatic compression
        // 自动压缩
        // Automatic compression
        if (
          newFile.file &&
          newFile.type.substr(0, 6) === 'image/' &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // Set an error to prevent being uploaded
          newFile.error = 'compressor'
          /* eslint-disable */
          new ImageCompressor(newFile.file, {
            quality: this.FMquality,
            /* eslint-ensable */
            width: this.FMwidth,
            height: this.FMheight,
            success: result => {
              // Successfully deleted the error to write the new file
              this.$refs.upload.update(newFile, {
                file: result,
                error: '',
                size: result.size,
                type: result.type
              })
            },
            error: e => {
              this.$refs.upload.update(newFile, { error: e.message })
            }
          })
        }
        // if (newFile.file && newFile.type.substr(0, 6) === 'image/' && this.autoCompress > 0 && this.autoCompress < newFile.size) {
        //   newFile.error = 'compressing'
        //   const imageCompressor = new ImageCompressor(null, {
        //     // convertSize: Infinity,
        //     /* eslint-disable */
        //     quality: .2,
        //     /*eslint-ensable */
        //     width: 1024,
        //     height: 1024
        //   })
        //   imageCompressor.compress(newFile.file)
        //     .then((file) => {
        //       this.$refs.upload.update(newFile, { error: '', file, size: file.size, type: file.type })
        //     })
        //     .catch((err) => {
        //       this.$refs.upload.update(newFile, { error: err.message || 'compress' })
        //     })
        // }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }

        // Thumbnails
        // 缩略图
        newFile.thumb = ''
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob
        }
      }
      if (newFile && oldFile && newFile.xhr && !newFile.xhr.withCredentials) {
        newFile.xhr.withCredentials = true
        console.log('XHR was set')
      }
    },

    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update

        if (newFile.active && !oldFile.active) {
          // beforeSend

          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.upload.update(newFile, { error: 'size' })
          }
        }

        if (newFile.progress !== oldFile.progress) {
          // progress
        }

        if (newFile.error && !oldFile.error) {
          // error
        }

        if (newFile.success && !oldFile.success) {
          // success
          this.getS3Files(this.currentDirectory)
        }
      }

      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response.id) {
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/upload/delete?id=' + oldFile.response.id,
          // })
        }
      }

      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
            if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log('response', newFile.response)
        if (newFile.xhr) {
          // xhr 的 withCredentials
          console.log(newFile.xhr.withCredentials)
          //  Get the response status code
          console.log('status', newFile.xhr.status)
        }
      }
    },

    alert(message) {
      alert(message)
    },

    onEditFileShow(file) {
      this.editFile = { ...file, show: true }
      this.$refs.upload.update(file, { error: 'edit' })
    },

    onEditorFile() {
      if (!this.$refs.upload.features.html5) {
        this.alert('Your browser does not support')
        this.editFile.show = false
        return
      }

      let data = {
        name: this.editFile.name
      }
      if (this.editFile.cropper) {
        let binStr = atob(
          this.editFile.cropper
            .getCroppedCanvas()
            .toDataURL(this.editFile.type)
            .split(',')[1]
        )
        let arr = new Uint8Array(binStr.length)
        for (let i = 0; i < binStr.length; i++) {
          arr[i] = binStr.charCodeAt(i)
        }
        data.file = new File([arr], data.name, { type: this.editFile.type })
        data.size = data.file.size
      }
      this.$refs.upload.update(this.editFile.id, data)
      this.editFile.error = ''
      this.editFile.show = false
    },

    // add folader
    onAddFolader() {
      if (!this.$refs.upload.features.directory) {
        this.alert('Your browser does not support')
        return
      }

      let input = this.$refs.upload.$el.querySelector('input')
      input.directory = true
      input.webkitdirectory = true
      this.directory = true

      input.onclick = null
      input.click()
      input.onclick = e => {
        this.directory = false
        input.directory = false
        input.webkitdirectory = false
      }
    },

    onAddData() {
      this.addData.show = false
      if (!this.$refs.upload.features.html5) {
        this.alert('Your browser does not support')
        return
      }

      let file = new window.File([this.addData.content], this.addData.name, {
        type: this.addData.type
      })
      this.$refs.upload.add(file)
    },
    getCookie(name) {
    let cookieArr = document.cookie.split(";")
    for(let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=")
        if(name == cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]) 
        }
    }
    // Return null if not found
    return 'null';
    }
  },
  computed: {
    assetsBaseUrl() {
      return this.$store.getters.assetsBaseUrl
    }
  },
  created() {
    this.getS3Files('root')
    this.getS3Folders('/')
  },
  components: {
    FileUpload
  }
}
</script>

<style scoped>
.example-full .btn-group .dropdown-menu {
  display: block;
  visibility: hidden;
  transition: all 0.2s;
}
.example-full .btn-group:hover > .dropdown-menu {
  visibility: visible;
}

.example-full label.dropdown-item {
  margin-bottom: 0;
}

.example-full .btn-group .dropdown-toggle {
  margin-right: 0.6rem;
}

.example-full .filename {
  margin-bottom: 0.3rem;
}

.example-full .btn-is-option {
  margin-top: 0.25rem;
}
.example-full .example-foorer {
  padding: 0.5rem 0;
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}

.example-full .edit-image img {
  max-width: 100%;
}

.example-full .edit-image-tool {
  margin-top: 0.6rem;
}

.example-full .edit-image-tool .btn-group {
  margin-right: 0.6rem;
}

.example-full .footer-status {
  padding-top: 0.4rem;
}

.example-full .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}

.example-full .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>
